<dx-range-slider width="100%" height="auto"
  [min]="min" [max]="max"
  [(start)]="value" [(end)]="otherValue"
  [tooltip]="tooltip" (valueChange)="onSelfChangeValue(value);"
  (otherValueChange)="onSelfChangeValue(otherValue);"
  (onFocusIn)="(!!onFocusIn && onFocusIn())"
  (onFocusOut)="(!!onFocusOut && onFocusOut())"></dx-range-slider>